const EVENT_NAME = "whaticket:pending-message";
const pendingMessages = new Map();

const emitPendingMessage = (detail) => {
  window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail }));
};

export const addPendingMessage = ({ ticketId, body, quotedMsg }) => {
  const id = `pending-${Date.now()}-${Math.random().toString(36).slice(2)}`;
  const detail = {
    action: "add",
    ticketId: Number(ticketId),
    message: {
      id,
      ticketId: Number(ticketId),
      body,
      fromMe: true,
      read: true,
      ack: 0,
      mediaType: "chat",
      mediaUrl: "",
      quotedMsg,
      createdAt: new Date().toISOString(),
      _isOptimistic: true,
      _sendStatus: "pending",
    },
  };
  pendingMessages.set(id, detail);
  emitPendingMessage(detail);
  return id;
};

export const markPendingMessageFailed = (ticketId, id) => {
  const current = pendingMessages.get(id);
  const detail = {
    action: "failed",
    ticketId: Number(ticketId),
    message: { id },
  };
  if (current) {
    pendingMessages.set(id, {
      ...current,
      message: { ...current.message, _sendStatus: "failed" },
    });
  }
  emitPendingMessage(detail);
};

export const resolvePendingMessage = (id) => {
  if (!id) return;

  const current = pendingMessages.get(id);
  if (!current) return;

  pendingMessages.delete(id);
  emitPendingMessage({
    action: "resolved",
    ticketId: current.ticketId,
    message: { id },
  });
};

export const getLatestPendingMessage = (ticketId) => {
  const normalizedTicketId = Number(ticketId);
  let latestMessage = null;

  pendingMessages.forEach((detail) => {
    if (Number(detail.ticketId) !== normalizedTicketId) return;

    const candidate = detail.message;
    if (
      !latestMessage ||
      new Date(candidate.createdAt).getTime() >=
        new Date(latestMessage.createdAt).getTime()
    ) {
      latestMessage = candidate;
    }
  });

  return latestMessage;
};

export const withPendingMessagePreview = (ticket) => {
  const pendingMessage = getLatestPendingMessage(ticket.id);
  const pendingCreatedAt = pendingMessage
    ? new Date(pendingMessage.createdAt).getTime()
    : 0;
  const ticketUpdatedAt = new Date(ticket.updatedAt).getTime();

  if (!pendingMessage || pendingCreatedAt <= ticketUpdatedAt) return ticket;

  return {
    ...ticket,
    lastMessage: pendingMessage.body,
    lastMessageFromMe: true,
    updatedAt: pendingMessage.createdAt,
    _pendingLastMessageStatus: pendingMessage._sendStatus,
  };
};

export const onPendingMessage = (listener) => {
  const handler = (event) => listener(event.detail);
  window.addEventListener(EVENT_NAME, handler);
  pendingMessages.forEach(listener);
  return () => window.removeEventListener(EVENT_NAME, handler);
};
